const HERO_IMAGE =
  'https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&w=1600&q=80';

const RELATED_GUIDES = [
  {
    slug: 'soccer-field-injury-remedies-calf-hamstring',
    title: 'On-Field Remedies for Soccer Calf, Soleus & Hamstring Injuries',
    blurb: 'first aid for tournament weekend muscle strains.',
  },
  {
    slug: '7v7-soccer-formation-over-35-guide',
    title: '7v7 Soccer Formation Guide for Players 35+',
    blurb: 'tactics and recovery for veteran rosters.',
  },
  {
    slug: 'ohio-indian-health-wellness-guide',
    title: 'Ohio Indian Health & Wellness Guide (All Ages)',
    blurb: 'meal and fitness plans for adult soccer players.',
  },
];

const REFERENCE_LINKS = [
  {
    label: 'Khiladiz Sports Club — 5th Annual NAMSL Tournament',
    url: 'https://www.khiladiz.com/the-5th-annual-namsl-soccer-tournament-in-baltimore-md-on-july-31-august-2-2026/',
  },
  {
    label: 'North American Malayalee Soccer League (NAMSL)',
    url: 'https://www.khiladiz.com/namsl/',
  },
  {
    label: 'Troy Park — Howard County Recreation & Parks',
    url: 'https://www.howardcountymd.gov/recreation-parks/troy-park',
  },
  {
    label: 'Kerala Association of Greater Washington — Mallu Pages',
    url: 'https://kagw.com/mallu-pages/',
  },
];

/** Kerala & South Indian restaurants near Baltimore for Khiladiz / NAMSL tournament visitors */
export const BALTIMORE_KERALA_RESTAURANTS_POST = {
  id: 'featured-baltimore-kerala-restaurants-khiladiz',
  slug: 'kerala-restaurants-baltimore-khiladiz-namsl-tournament',
  title: 'Best Kerala Restaurants Near Baltimore for the Khiladiz NAMSL Tournament',
  excerpt:
    'Where to eat appam, fish curry, and Kerala-style meals during the 5th Annual NAMSL tournament at Troy Park, Elkridge—restaurants from Elkridge to Columbia, Baltimore city, and beyond.',
  publishedAt: '2026-07-29T12:00:00.000Z',
  coverImageUrl: HERO_IMAGE,
  authorName: 'Daily Sports Life',
  clubName: 'Maryland Field Guide',
  blogCategory: 'club-news',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'More guides for tournament weekend',
  relatedPosts: RELATED_GUIDES,
  referenceLinks: REFERENCE_LINKS,
  sections: [
    {
      type: 'stats',
      ariaLabel: 'Guide overview',
      items: [
        { value: '12 spots', label: 'Restaurants & kitchens listed' },
        { value: 'Troy Park', label: 'Elkridge, MD 21075' },
        { value: 'Jul 31–Aug 2', label: '2026 NAMSL weekend' },
        { value: '5–45 min', label: 'Drive from tournament venue' },
      ],
    },
    {
      type: 'panel',
      title: 'Tournament weekend at a glance',
      paragraphs: [
        'The **Khiladiz Sports Club** (Baltimore Khiladiz) hosts the **5th Annual V. P. Sathyan Memorial Soccer Tournament** — the North American Malayalee Soccer League (NAMSL) championship — **July 31 through August 2, 2026** at **Troy Park** in Elkridge, Maryland (6500 Mansion Ln, Elkridge, MD 21075).',
        'Khiladiz has roots in Baltimore’s Malayalee community since 1988. Teams fly in from across the country; after morning matches, everyone wants the same thing: **real Kerala food** — appam with stew, meen curry, beef fry, parotta, and filter coffee.',
        'Baltimore does not have many restaurants that serve *only* Kerala cuisine. This guide lists the **best nearby options** for Kerala-style and South Indian dishes, sorted by drive time from Troy Park. Hours and menus change — call ahead on tournament weekend.',
      ],
      chips: ['Khiladiz', 'NAMSL 2026', 'Troy Park', 'Kerala food', 'Elkridge MD'],
    },
    {
      type: 'table',
      title: 'Closest to Troy Park — under 20 minutes',
      intro:
        'These are your best bets between matches or for a quick team dinner Friday night. Elkridge and Hanover sit right next to the tournament complex.',
      headers: ['Restaurant', 'Address / drive', 'Kerala & South Indian picks', 'Good for'],
      rows: [
        [
          'Spice N Curry',
          '6590 Old Waterloo Rd, Elkridge, MD 21075 · ~5 min from Troy Park',
          'Goat pepper fry, chicken pepper fry, shrimp pepper fry, uthappam, masala vada, lamb curry',
          'Closest sit-down option; easy carryout between games; closed Mondays',
        ],
        [
          'Rangoli Restaurant',
          '7791-C Arundel Mills Blvd, Hanover, MD 21076 · ~12 min',
          'Masala dosa, plain dosa, full Indian menu with South Indian section',
          'Large groups near Arundel Mills; mall parking; dine-in and delivery',
        ],
        [
          'Mango Grove',
          '8865 Stanford Blvd Unit 107, Columbia, MD 21045 · ~15 min',
          'Kerala dishes on menu, fish curry, masala dosa, biryani, lunch buffet options',
          'Family-style meals; vegetarian and vegan choices; serves Elkridge and Columbia',
        ],
      ],
    },
    {
      type: 'panel',
      title: 'Pick #1 — Spice N Curry (closest to the fields)',
      orderedList: [
        'From Troy Park, head south on US-1 / Washington Blvd — under 10 minutes in light traffic.',
        'Order goat or chicken **pepper fry** and **uthappam** for a taste close to Kerala home cooking.',
        'Call (443) 661-4217 before a big group; the dining room is modest but the kitchen is fast.',
        'Closed Monday — plan Friday or weekend visits during the tournament.',
        'Pair with a post-match stop at a grocery on Waterloo Rd for bananas and coconut water.',
      ],
      callout:
        'Hours (typical): Tue–Thu 11 AM–9 PM, Fri–Sat 11 AM–9:30 PM, Sun 11 AM–9:30 PM. Confirm before you drive.',
    },
    {
      type: 'table',
      title: 'Columbia & Ellicott City — 15–25 minutes (Howard County)',
      intro:
        'Howard County has one of the strongest Indian dining corridors in the Baltimore metro. Worth the short drive for a proper post-finals dinner.',
      headers: ['Restaurant', 'Address / drive', 'Kerala & South Indian picks', 'Good for'],
      rows: [
        [
          'Sangam Indian Cuisine (Ellicott City)',
          '10039 Baltimore National Pike, Unit A, Ellicott City, MD 21042 · ~20 min',
          'Appam specials with curry, five thali platters, dosas, goat biryani — Baltimore Magazine pick',
          'Best appam near the tournament; classy dine-in; weekend lunch thali',
        ],
        [
          'Dwaraka\'s Bawarchi Indian Kitchen',
          '7185 Columbia Gateway Dr, Suites A & B, Columbia, MD 21046 · ~18 min',
          'Hyderabadi and Andhra biryanis, shrimp fry, Apollo fish, Gongura paneer biryani',
          'Feeding 10+ players; near Columbia Gateway Costco; heavy biryani orders',
        ],
        [
          'Curry & Kabob',
          '5325 Village Center Dr, Columbia, MD 21044 · ~20 min',
          'Indian and Nepalese menu, curries, tandoor, Himalayan dishes',
          'Owen Brown / Columbia Town Center area; halal-friendly options',
        ],
      ],
    },
    {
      type: 'panel',
      title: 'Pick #2 — Sangam Ellicott City (appam & thali night)',
      paragraphs: [
        'Sangam’s **appam specials** — pale, lacy rice-and-coconut pancakes with small bowls of curry — are the dish most Malayalee visitors ask for after a long tournament day. Baltimore Magazine called out the goat biryani and thali spreads as standouts.',
        'The Ellicott City location is newer than the original Cockeysville Sangam; both are strong for South Indian food. Ellicott City is slightly closer to Troy Park.',
      ],
      list: [
        'Address: 10039 Baltimore National Pike, Unit A, Ellicott City, MD 21042',
        'Phone: (410) 313-8818',
        'Typical hours: Mon–Fri 11:30 AM–2:30 PM & 5:30–9:30 PM; Sat–Sun 11:30 AM–3 PM & 5:30–10 PM',
        'Order appam, a goat or vegetable thali, and filter coffee if available.',
        'Bring 3–4 friends — portions are built for sharing.',
      ],
    },
    {
      type: 'table',
      title: 'Baltimore City — 25–35 minutes',
      intro:
        'Staying downtown or near Johns Hopkins? These city spots work for a Friday arrival dinner or Sunday night send-off.',
      headers: ['Restaurant', 'Address / drive', 'Kerala & South Indian picks', 'Good for'],
      rows: [
        [
          'Unavu',
          '416 E 30th St, Baltimore, MD 21218 (Charles Village) · ~25 min',
          'Homestyle South Indian: dosas, idli, sambar, kothu parotta — The Baltimore Banner featured',
          'Pickup and delivery ghost kitchen; grandma-style cooking; near Hopkins campus',
        ],
        [
          'Akbar Restaurant',
          '823 N Charles St, Baltimore, MD 21201 · ~25 min',
          'Kerala pepper chicken, crab Malabar, fish curry, goat curry, vegetarian thali',
          'Mount Vernon dine-in; elegant setting; named Kerala dishes on menu',
        ],
        [
          'Namaste Baltimore',
          '413 W Cold Spring Ln, Baltimore, MD 21210 · ~30 min',
          'Indian and Nepali: momos, dal tadka, shrimp bhuna, paratha; halal',
          'Family-owned; catering for team events — call Binod @ (443) 610-9118',
        ],
      ],
    },
    {
      type: 'panel',
      title: 'Pick #3 — Akbar Restaurant (Kerala dishes by name)',
      paragraphs: [
        'Akbar is a long-running Mount Vernon institution. While the menu spans North and South India, they explicitly list **Kerala pepper chicken** and **crab Malabar** — rare on a Baltimore menu. Good for visitors staying in the Inner Harbor or Federal Hill who want a sit-down dinner with Kerala options.',
      ],
      list: [
        'Address: 823 N Charles St #B, Baltimore, MD 21201',
        'Phone: (410) 539-0944',
        'Try: Kerala pepper chicken, crab Malabar, fish curry, goat/shahjehani biryani',
        'Hours: Mon–Wed 11 AM–10 PM, Thu–Sat 11 AM–11 PM, Sun 11 AM–10 PM',
        'Valet and street parking in Mount Vernon — allow extra time on weekend nights.',
      ],
    },
    {
      type: 'table',
      title: 'Worth the drive — 30–50 minutes',
      intro:
        'If your team rents a house in Columbia or you have a rest day, these spots reward the extra miles.',
      headers: ['Restaurant', 'Address / drive', 'Kerala & South Indian picks', 'Good for'],
      rows: [
        [
          'Sangam Indian Cuisine (Cockeysville)',
          '112 Cranbrook Rd, Cockeysville, MD 21030 · ~35 min north',
          'Dosas, idli, uttapam, mutton thali — original location; Hopkins students swear by it',
          'Northern Baltimore County teams; spacious dining room',
        ],
        [
          'Kaveri South Indian Restaurant',
          '9011 Gaither Rd, Gaithersburg, MD 20877 · ~45 min',
          'Kerala on menu, Hyderabadi biryani, Andhra curries, weekend buffet with live dosa counter',
          'All-you-can-eat Saturday/Sunday buffet; big Malayalee crowd from DC suburbs',
        ],
        [
          'Omade Foods (app / marketplace)',
          'DMV-wide home chefs · order via app',
          'Homemade Kerala and South Indian from local home kitchens — sadya-style orders sometimes',
          'Pre-order appam or fish curry for team housing; check chef availability in Columbia/Elkridge',
        ],
      ],
    },
    {
      type: 'panel',
      title: 'Homestyle option — Omade Foods',
      paragraphs: [
        '**Omade** is not a restaurant — it is a marketplace app connecting you with home chefs who cook authentic Indian food for pickup or delivery. For tournament teams staying in Airbnbs near Troy Park, this can be the closest thing to **amma’s appam** without flying to Kochi.',
        'Download the Omade app, set your Maryland zip code (21075 for Elkridge), and browse chefs offering Kerala or South Indian menus. Order a day ahead for large trays.',
      ],
      chips: ['Home chefs', 'Bulk orders', 'App-based', 'DMV-wide'],
    },
    {
      type: 'table',
      title: 'What to order — Kerala favorites for soccer weekends',
      headers: ['Dish', 'What it is', 'Where to find it nearby'],
      rows: [
        ['Appam with stew', 'Fermented rice pancakes with coconut milk curry', 'Sangam Ellicott City'],
        ['Beef fry / pepper fry', 'Spiced dry-fry meat with curry leaves and pepper', 'Spice N Curry (goat/chicken pepper fry)'],
        ['Meen (fish) curry', 'Tamarind or coconut-based fish curry', 'Akbar, Mango Grove'],
        ['Parotta / kothu parotta', 'Layered flatbread, sometimes chopped with egg and meat', 'Unavu (kothu parotta)'],
        ['Sadya / thali', 'Multi-dish platter on banana leaf or steel plate', 'Sangam thali specials; Omade for pre-ordered sadya'],
        ['Filter coffee', 'South Indian drip coffee with frothy milk', 'Sangam, Kaveri buffet weekends'],
        ['Biryani (Malabar style)', 'Fragrant rice with meat or seafood', 'Sangam goat biryani, Dwaraka\'s Bawarchi, Kaveri'],
      ],
    },
    {
      type: 'panel',
      title: 'Team dinner planning tips',
      orderedList: [
        '**Friday night** — book a table at Sangam Ellicott City or Dwaraka\'s Bawarchi for 15+ people; call 48 hours ahead.',
        '**Saturday lunch** — Spice N Curry or Mango Grove carryout to Troy Park picnic areas (check park rules on outside food).',
        '**Halal needs** — Namaste Baltimore and several Columbia restaurants label halal proteins; confirm when ordering.',
        '**Vegetarian rosters** — Mango Grove, Sangam thali, and Unavu all have strong veg menus.',
        '**Catering** — Namaste Baltimore (443-610-9118) and Akbar cater large events; order by Wednesday for tournament weekend.',
        '**Traffic** — US-1 and I-95 toward Elkridge back up after 5 PM; eat early or stay in Howard County.',
      ],
    },
    {
      type: 'panel',
      title: 'Getting to Troy Park from dinner',
      list: [
        'Troy Park: 6500 Mansion Ln, Elkridge, MD 21075',
        'From Columbia: take MD-100 east to US-1 south — about 15 minutes.',
        'From Baltimore city: I-95 south to MD-100 east, or US-1 south through Elkridge.',
        'From Arundel Mills / Hanover: MD-100 west to US-1 south — about 15 minutes.',
        'Parking at Troy Park is free for tournament events; arrive 45 minutes before kickoff on busy bracket days.',
      ],
      callout:
        'Tournament dates: **July 31 – August 2, 2026**. Follow Khiladiz Sports Club at khiladiz.com for bracket times and field assignments.',
    },
    {
      type: 'panel',
      title: 'A note on authenticity',
      paragraphs: [
        'Most restaurants on this list are **South Indian or pan-Indian** kitchens with Kerala-adjacent dishes — not exclusive Kerala houses like you would find in Kochi or Thiruvananthapuram. That is normal for the Baltimore–DC corridor.',
        'For the truest Malayalee community experience beyond restaurants, connect with the **Kerala Association of Greater Washington (KAGW)** and **World Malayalee Council DC Province** — they coordinate Onam sadya and cultural events across Maryland, DC, and Virginia.',
        'Menus, hours, and prices change. Verify on Google Maps or the restaurant website before you drive. This guide is for planning only — not a paid endorsement of any venue.',
      ],
    },
  ],
};
